import i18n from "../../i18n";
import { AxisKey } from "./types";

// Ring order, innermost → outermost (spec: Focus, Energy, Pace, Direction).
export const RING_ORDER: AxisKey[] = ["focus", "energy", "pace", "direction"];

// Card / legend order.
export const CARD_ORDER: AxisKey[] = ["direction", "pace", "energy", "focus"];

// Colours only; the words come from the locale files ("lifeGps.*").
export const AXIS_META: Record<
  AxisKey,
  {
    ring: string; // stroke colour (decorative)
    text: string; // darker shade of the same hue, WCAG AA on white
  }
> = {
  direction: { ring: "#A78BFF", text: "#A78BFF" },
  pace: { ring: "#9AD7FF", text: "#9AD7FF" },
  energy: { ring: "#C27BFF", text: "#C27BFF" },
  focus: { ring: "#7A7FFF", text: "#9EA3FF" },
};

export const axisLabel = (axis: AxisKey) => i18n.t(`lifeGps.axis.${axis}`);

// short legend / micro label
export const axisHelper = (axis: AxisKey) => i18n.t(`lifeGps.axisHelper.${axis}`);

// The state enum stays English in the data; only its display is translated.
export const stateLabel = (axis: AxisKey, state: string) =>
  i18n.t(`lifeGps.state.${axis}.${state}`, {
    defaultValue: state.charAt(0).toUpperCase() + state.slice(1),
  });

// One plain line per state, so words like "transitional" are never a mystery.
export const stateHelp = (axis: AxisKey, state: string) =>
  i18n.t(`lifeGps.stateHelp.${axis}.${state}`, { defaultValue: "" });

export const windowLabel = (window: string) =>
  i18n.t(`lifeGps.window.${window}`, { defaultValue: i18n.t("lifeGps.window.now") });

// What each personalization source means (shown in the compact panel).
const SOURCES = ["chart", "chartTiming", "journeyNodes", "emotionalPatterns", "userDecisions"];
export const sourceExplanation = (source: string) =>
  SOURCES.includes(source) ? i18n.t(`lifeGps.source.${source}`) : "";
